import { em } from 'polished'
import styled from 'styled-components'

export const PictureWrapper = styled.div`
  width: 100%;
  margin: ${em(40)} auto;

  ${p => p.theme.mq.upMd} {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 10%);
    height: ${em(400)};
    margin-top: 0;
    margin-bottom: 0;
  }

  ${p => p.theme.mq.upLg} {
    left: 0;
    transform: translate(-15%, 10%);
  }
`
